import { Decimal } from 'decimal.js';
import z from 'zod';
// Validation regex for decimal strings
const DECIMAL_STRING_REGEX = /^(?:[+-]?(?:[0-9]+(?:.[0-9]+)?(?:[eE][+-]?[0-9]+)?|Infinity)|NaN)$/;
// Validation function that accepts decimal-like values
const isValidDecimal = (v) => {
    if (v === undefined || v === null)
        return false;
    return (Decimal.isDecimal(v) ||
        (typeof v === 'object' &&
            v !== null &&
            'd' in v &&
            'e' in v &&
            's' in v &&
            'toFixed' in v &&
            Array.isArray(v.d) &&
            typeof v.e === 'number' &&
            typeof v.s === 'number' &&
            typeof v.toFixed === 'function') ||
        (typeof v === 'string' && DECIMAL_STRING_REGEX.test(v)) ||
        typeof v === 'number');
};
export const zodDecimal = () => z.preprocess((val) => {
    if (Decimal.isDecimal(val)) {
        return val;
    }
    if (typeof val === 'string' || typeof val === 'number') {
        return new Decimal(val);
    }
    return val;
}, z.instanceof(Decimal).refine(isValidDecimal, {
    message: 'Input not instance of Decimal',
}));
// An amount of money: `Payment.amount` is `Decimal(10,2)`, so a third decimal would make the
// écriture and the payment it belongs to disagree.
export const zodMoney = () => zodDecimal().refine((value) => value.decimalPlaces() <= 2, {
    message: 'Le montant ne peut pas avoir plus de deux décimales',
});
